exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.view-data[data-v-2e50ea7c] {\n    max-height: 50vh;\n    overflow-y: auto;\n}\n", ""]);

// exports
